<template>
  <v-container id="regular-forms" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="grey darken-3"
          icon="mdi-account"
          :title="$route.params.id ? $t('Edit Course') : $t('New Course')"
          class="px-5 py-3"
        >
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <v-form
            v-else
            ref="form"
            autocomplete="new-password"
            lazy-validation
            @submit.prevent="saveItem"
          >
            <v-tabs v-model="tab" dark left background-color="grey darken-3">
              <v-tab href="#tab-1">{{ $t("Basisdaten") }}</v-tab>
              <v-tab href="#tab-2">{{ $t("Erweitert") }}</v-tab>
              <v-tab href="#tab-3">{{ $t("Email") }}</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item value="tab-1">
                <v-card flat>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="formValues.name"
                        :label="$t('name')"
                        autocomplete="new-password"
                        v-validate="'required'"
                        required
                        data-vv-name="name"
                        :error-messages="errors.collect('name')"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="formValues.name_it"
                        :label="$t('name_it')"
                        autocomplete="new-password"
                        v-validate="'required'"
                        required
                        data-vv-name="name_it"
                        :error-messages="errors.collect('name_it')"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-switch
                        v-model="formValues.active"
                        :label="$t('active')"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-select
                        v-model="formValues.course_type_id"
                        :items="courseTypes"
                        :label="$t('Coursetype')"
                        item-text="name"
                        item-value="id"
                        :error-messages="errors.collect('course_type_id')"
                      ></v-select>
                    </v-col>
                    <v-col>
                      <v-select
                        v-model="formValues.location_id"
                        :items="locations"
                        :label="$t('Location')"
                        item-text="name"
                        item-value="id"
                        :error-messages="errors.collect('location_id')"
                      ></v-select>
                    </v-col>
                    <!-- <v-col>
                      <v-autocomplete
                        v-model="formValues.courseCategories"
                        multiple
                        :items="courseCategories"
                        :label="$t('Coursecategories')"
                        item-text="name"
                        item-value="id"
                        v-validate=""
                        data-vv-name="courseCategories"
                        :error-messages="errors.collect('courseCategories')"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            close
                            @click="data.select"
                            @click:close="removeCourseCategory(data.item)"
                          >
                            {{ data.item.name }}
                          </v-chip>
                        </template>
                        <template v-slot:item="data">
                          {{ data.item.name }}
                        </template>
                      </v-autocomplete>
                    </v-col> -->
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-autocomplete
                        v-model="formValues.reference_course_id"
                        :items="courses"
                        :label="$t('reference_course_id')"
                        item-text="name"
                        item-value="id"
                        :error-messages="errors.collect('reference_course_id')"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>

                  <v-divider class="mt-5 mb-5" />

                  <!-- start Anmeldezeitraum -->
                  <h5>1. {{ $t("registration") }}</h5>
                  <v-row>
                    <v-col>
                      <base-date-picker
                        v-model="formValues.register_from"
                        :label="
                          $t('Course') +
                            ' ' +
                            $t('registration') +
                            ' ' +
                            $t('from')
                        "
                        :errors="errors.collect('register_from')"
                      ></base-date-picker>
                    </v-col>
                    <v-col>
                      <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="time"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="formValues.register_from_time"
                            :label="
                              $t('Course') +
                                ' ' +
                                $t('registration') +
                                ' ' +
                                $t('from') +
                                ' ' +
                                $t('time')
                            "
                            prepend-icon="mdi-clock-time-four-outline"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :errors="errors.collect('register_from_time')"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="menu"
                          v-model="formValues.register_from_time"
                          format="24hr"
                          full-width
                          @click:minute="
                            $refs.menu.save(formValues.register_from_time)
                          "
                        ></v-time-picker>
                      </v-menu>
                    </v-col>
                    <v-col>
                      <base-date-picker
                        v-model="formValues.register_to"
                        :label="
                          $t('Course') +
                            ' ' +
                            $t('registration') +
                            ' ' +
                            $t('to')
                        "
                        :errors="errors.collect('register_to')"
                      ></base-date-picker>
                    </v-col>
                    <v-col>
                      <v-menu
                        ref="menu3"
                        v-model="menu3"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="time"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="formValues.register_to_time"
                            :label="
                              $t('Course') +
                                ' ' +
                                $t('registration') +
                                ' ' +
                                $t('to') +
                                ' ' +
                                $t('time')
                            "
                            prepend-icon="mdi-clock-time-four-outline"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :errors="errors.collect('register_to_time')"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="menu3"
                          v-model="formValues.register_to_time"
                          format="24hr"
                          full-width
                          @click:minute="
                            $refs.menu3.save(formValues.register_to_time)
                          "
                        ></v-time-picker>
                      </v-menu>
                    </v-col>
                  </v-row>

                  <h5>2. {{ $t("registration") }}</h5>
                  <v-row>
                    <v-col>
                      <base-date-picker
                        v-model="formValues.register_from_phase2"
                        :label="
                          $t('Course') +
                            ' ' +
                            $t('registration') +
                            ' ' +
                            $t('from')
                        "
                        :errors="errors.collect('register_from')"
                      ></base-date-picker>
                    </v-col>
                    <v-col>
                      <v-menu
                        ref="menu2"
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="time2"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="formValues.register_from_time_phase2"
                            :label="
                              $t('Course') +
                                ' ' +
                                $t('registration') +
                                ' ' +
                                $t('from') +
                                ' ' +
                                $t('time')
                            "
                            prepend-icon="mdi-clock-time-four-outline"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :errors="errors.collect('register_from_time')"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="menu2"
                          v-model="formValues.register_from_time_phase2"
                          format="24hr"
                          full-width
                          @click:minute="
                            $refs.menu2.save(
                              formValues.register_from_time_phase2
                            )
                          "
                        ></v-time-picker>
                      </v-menu>
                    </v-col>
                    <v-col>
                      <base-date-picker
                        v-model="formValues.register_to_phase2"
                        :label="
                          $t('Course') +
                            ' ' +
                            $t('registration') +
                            ' ' +
                            $t('to')
                        "
                        :errors="errors.collect('register_to')"
                      ></base-date-picker>
                    </v-col>
                    <v-col>
                      <v-menu
                        ref="menu4"
                        v-model="menu4"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="time"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="formValues.register_to_time_phase2"
                            :label="
                              $t('Course') +
                                ' ' +
                                $t('registration') +
                                ' ' +
                                $t('to') +
                                ' ' +
                                $t('time')
                            "
                            prepend-icon="mdi-clock-time-four-outline"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :errors="errors.collect('register_to_time_phase2')"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="menu4"
                          v-model="formValues.register_to_time_phase2"
                          format="24hr"
                          full-width
                          @click:minute="
                            $refs.menu4.save(formValues.register_to_time_phase2)
                          "
                        ></v-time-picker>
                      </v-menu>
                    </v-col>
                  </v-row>

                  <!-- end Anmeldezeitraum -->
                  <v-divider class="mt-5 mb-5" />

                  <v-row>
                    <v-col>
                      <base-date-picker
                        v-model="formValues.from"
                        :label="$t('Course') + ' ' + $t('from')"
                        :errors="errors.collect('from')"
                      ></base-date-picker>
                    </v-col>
                    <v-col>
                      <base-date-picker
                        v-model="formValues.to"
                        :label="$t('Course') + ' ' + $t('to')"
                        :errors="errors.collect('to')"
                      ></base-date-picker>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="formValues.max_participants"
                        :label="$t('max_participants')"
                        autocomplete="new-password"
                        v-validate="'required'"
                        required
                        data-vv-name="max_participants"
                        :error-messages="errors.collect('max_participants')"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="formValues.waiting_list"
                        :label="$t('waiting_list')"
                        autocomplete="new-password"
                        v-validate="'required'"
                        required
                        data-vv-name="waiting_list"
                        :error-messages="errors.collect('waiting_list')"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="formValues.price"
                        :label="$t('price')"
                        autocomplete="new-password"
                        v-validate="'required'"
                        required
                        data-vv-name="price"
                        :error-messages="errors.collect('price')"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-switch
                        v-model="formValues.custom_field"
                        :label="$t('custom_field')"
                      ></v-switch>
                    </v-col>
                    <v-col v-show="formValues.custom_field">
                      <v-text-field
                        v-model="formValues.custom_field_de"
                        :label="$t('name') + ' ' + $t('custom_field') + ' DE'"
                        autocomplete="new-password"
                        v-validate="'required'"
                        required
                        data-vv-name="custom_field_de"
                        :error-messages="errors.collect('custom_field_de')"
                      ></v-text-field>
                    </v-col>
                    <v-col v-show="formValues.custom_field">
                      <v-text-field
                        v-model="formValues.custom_field_it"
                        :label="$t('name') + ' ' + $t('custom_field') + ' IT'"
                        autocomplete="new-password"
                        v-validate="'required'"
                        required
                        data-vv-name="custom_field_it"
                        :error-messages="errors.collect('custom_field_it')"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-switch
                        v-model="formValues.custom_field_2"
                        :label="$t('custom_field_2')"
                      ></v-switch>
                    </v-col>
                    <v-col v-show="formValues.custom_field_2">
                      <v-text-field
                        v-model="formValues.custom_field_2_de"
                        :label="$t('name') + ' ' + $t('custom_field_2') + ' DE'"
                        autocomplete="new-password"
                        v-validate="'required'"
                        required
                        data-vv-name="custom_field_2_de"
                        :error-messages="errors.collect('custom_field_2_de')"
                      ></v-text-field>
                    </v-col>
                    <v-col v-show="formValues.custom_field_2">
                      <v-text-field
                        v-model="formValues.custom_field_2_it"
                        :label="$t('name') + ' ' + $t('custom_field_2') + ' IT'"
                        autocomplete="new-password"
                        v-validate="'required'"
                        required
                        data-vv-name="custom_field_2_it"
                        :error-messages="errors.collect('custom_field_2_it')"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-switch
                        v-model="formValues.community_resident_required_phase1"
                        :label="$t('community_resident_required_phase1')"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-switch
                        v-model="formValues.custom_labels"
                        :label="$t('custom_labels')"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <v-row v-if="formValues.custom_labels">
                    <v-col>
                      <v-card>
                        <v-card-text>
                          <v-text-field
                            v-model="formValues.label_half_day_de"
                            :label="$t('label_half_day_de')"
                            autocomplete="new-password"
                            v-validate="'required'"
                            required
                            data-vv-name="label_half_day_de"
                            :error-messages="
                              errors.collect('label_half_day_de')
                            "
                          ></v-text-field>
                          <v-text-field
                            v-model="formValues.label_half_day_it"
                            :label="$t('label_half_day_it')"
                            autocomplete="new-password"
                            v-validate="'required'"
                            required
                            data-vv-name="label_half_day_it"
                            :error-messages="
                              errors.collect('label_half_day_it')
                            "
                          ></v-text-field>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col>
                      <v-card>
                        <v-card-text>
                          <v-text-field
                            v-model="formValues.label_full_day_de"
                            :label="$t('label_full_day_de')"
                            autocomplete="new-password"
                            v-validate="'required'"
                            required
                            data-vv-name="label_full_day_de"
                            :error-messages="
                              errors.collect('label_full_day_de')
                            "
                          ></v-text-field>
                          <v-text-field
                            v-model="formValues.label_full_day_it"
                            :label="$t('label_full_day_it')"
                            autocomplete="new-password"
                            v-validate="'required'"
                            required
                            data-vv-name="label_full_day_it"
                            :error-messages="
                              errors.collect('label_full_day_it')
                            "
                          ></v-text-field>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                  <courseWeek v-if="formValues.id" :course="formValues">
                  </courseWeek>
                  <v-card>
                    <h3 class="mt-2 mb-3">{{ $t("Bankdaten") }}</h3>
                    <v-row>
                      <v-col>
                        <v-text-field
                          v-model="formValues.bank_name"
                          :label="$t('bank_name')"
                          autocomplete="new-password"
                          v-validate="'required'"
                          required
                          data-vv-name="bank_name"
                          :error-messages="errors.collect('bank_name')"
                        ></v-text-field>
                      </v-col>
                      <v-col>
                        <v-text-field
                          v-model="formValues.bank_iban"
                          :label="$t('bank_iban')"
                          autocomplete="new-password"
                          v-validate="'required'"
                          required
                          data-vv-name="bank_iban"
                          :error-messages="errors.collect('bank_iban')"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-card>
              </v-tab-item>
              <v-tab-item value="tab-2">
                <v-card flat>
                  <v-row>
                    <v-col>
                      <p>{{ $t("description") }}</p>
                      <VueEditor
                        v-model="formValues.description"
                        autocomplete="new-password"
                        v-validate=""
                        data-vv-name="description"
                        :error-messages="errors.collect('description')"
                        :editor-toolbar="customToolbar"
                      ></VueEditor>
                    </v-col>
                    <v-col>
                      <p>{{ $t("description_it") }}</p>
                      <VueEditor
                        v-model="formValues.description_it"
                        autocomplete="new-password"
                        v-validate=""
                        data-vv-name="description_it"
                        :error-messages="errors.collect('description_it')"
                        :editor-toolbar="customToolbar"
                      ></VueEditor>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <p>{{ $t("info") }}</p>
                      <VueEditor
                        v-model="formValues.info"
                        :label="$t('info')"
                        autocomplete="new-password"
                        v-validate=""
                        data-vv-name="info"
                        :error-messages="errors.collect('info')"
                        :editor-toolbar="customToolbar"
                      ></VueEditor>
                    </v-col>
                    <v-col>
                      <p>{{ $t("info_it") }}</p>
                      <VueEditor
                        v-model="formValues.info_it"
                        :label="$t('info_it')"
                        autocomplete="new-password"
                        v-validate=""
                        data-vv-name="infoit"
                        :error-messages="errors.collect('info_it')"
                        :editor-toolbar="customToolbar"
                      ></VueEditor>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <p>{{ $t("image") }}</p>
                      <v-file-input
                        v-if="formValues.image == null"
                        filled
                        prepend-icon="mdi-camera"
                        v-model="chosenImage"
                        truncate-length="15"
                        show-size
                        v-on:change="onChangeImageUpload()"
                      ></v-file-input>
                      <div v-else>
                        <v-img :src="formValues.image" aspect-ratio="2">
                        </v-img>
                        <v-btn
                          @click="
                            formValues.image = null;
                            $forceUpdate();
                          "
                          class="mt-2"
                          color="error"
                          >{{ $t("image") }} {{ $t("delete") }}</v-btn
                        >
                      </div>
                    </v-col>
                    <v-col>
                      <p>{{ $t("program") }}</p>
                      <v-file-input
                        v-if="formValues.program == null"
                        filled
                        prepend-icon="mdi-file"
                        v-model="chosenFile"
                        truncate-length="15"
                        show-size
                        v-on:change="onChangeFileUpload('program')"
                      ></v-file-input>
                      <div v-else>
                        <v-btn
                          class="mt-2 mr-2"
                          taregt="_blank"
                          :href="formValues.program"
                          >{{ $t("program") }} {{ $t("download") }}
                        </v-btn>
                        <v-btn
                          @click="
                            formValues.program = null;
                            $forceUpdate();
                          "
                          class="mt-2"
                          color="error"
                          >{{ $t("program") }} {{ $t("delete") }}</v-btn
                        >
                      </div>

                      <br /><br />

                      <p>{{ $t("house_rules") }}</p>
                      <v-file-input
                        v-if="formValues.house_rules == null"
                        filled
                        prepend-icon="mdi-file"
                        v-model="chosenFileHouseRules"
                        truncate-length="15"
                        show-size
                        v-on:change="onChangeFileUpload('house_rules')"
                      ></v-file-input>
                      <div v-else>
                        <v-btn
                          class="mt-2 mr-2"
                          taregt="_blank"
                          :href="formValues.house_rules"
                          >{{ $t("house_rules") }} {{ $t("download") }}
                        </v-btn>
                        <v-btn
                          @click="
                            formValues.house_rules = null;
                            $forceUpdate();
                          "
                          class="mt-2"
                          color="error"
                          >{{ $t("house_rules") }} {{ $t("delete") }}</v-btn
                        >
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
              <v-tab-item value="tab-3">
                <v-card>
                  <h3 class="mt-2 mb-3">{{ $t("Bankdaten") }}</h3>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="formValues.bank_name"
                        :label="$t('bank_name')"
                        autocomplete="new-password"
                        v-validate="'required'"
                        required
                        data-vv-name="bank_name"
                        :error-messages="errors.collect('bank_name')"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="formValues.bank_iban"
                        :label="$t('bank_iban')"
                        autocomplete="new-password"
                        v-validate="'required'"
                        required
                        data-vv-name="bank_iban"
                        :error-messages="errors.collect('bank_iban')"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <template class="mt-5" flat v-if="$route.params.id">
                        <h3 class="mt-2 mb-3">
                          {{ $t("Emails - Zusatztexte") }}
                        </h3>
                        <v-tabs
                          v-model="subtab"
                          dark
                          left
                          background-color="grey darken-3"
                        >
                          <v-tab href="#subtab-1">{{
                            $t("Anmeldemail")
                          }}</v-tab>
                          <v-tab href="#subtab-2">{{
                            $t("Nachgerückt Mail")
                          }}</v-tab>
                          <v-tab href="#subtab-3">{{ $t("Warteliste") }}</v-tab>
                          <v-tab href="#subtab-4">{{ $t("Abgemeldet") }}</v-tab>
                          <v-tab href="#subtab-5">{{ $t("Bezahlt") }}</v-tab>
                        </v-tabs>
                        <v-tabs-items v-model="subtab">
                          <v-tab-item value="subtab-1">
                            <v-card class="pa-3">
                              <v-dialog v-model="dialog1" width="900">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    color="primary"
                                    class="mr-2"
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    {{ $t("Anmeldemail") }}
                                  </v-btn>
                                </template>
                                <v-card>
                                  <v-toolbar dark color="primary">{{
                                    $t("Anmeldemail")
                                  }}</v-toolbar>
                                  <iframe
                                    style="width:100%; height:500px;"
                                    :src="
                                      '/mail-preview/' +
                                        $route.params.id +
                                        '/new' +
                                        '?token=' +
                                        this.token
                                    "
                                  ></iframe> </v-card
                              ></v-dialog>
                              <hr class="mt-3 mb-3" />
                              <v-row>
                                <v-col>
                                  <p>{{ $t("Email Text DE") }}</p>
                                  <VueEditor
                                    v-model="formValues.email_new"
                                    autocomplete="new-password"
                                    v-validate=""
                                    data-vv-name="email_new"
                                    :error-messages="
                                      errors.collect('email_new')
                                    "
                                    :editor-toolbar="customToolbar"
                                  ></VueEditor>
                                </v-col>
                                <v-col>
                                  <p>{{ $t("Email Text IT") }}</p>
                                  <VueEditor
                                    v-model="formValues.email_new_it"
                                    autocomplete="new-password"
                                    v-validate=""
                                    data-vv-name="email_new_it"
                                    :error-messages="
                                      errors.collect('email_new_it')
                                    "
                                    :editor-toolbar="customToolbar"
                                  ></VueEditor>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-tab-item>
                          <v-tab-item value="subtab-2">
                            <v-card class="pa-3">
                              <v-dialog v-model="dialog2" width="900">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    color="primary"
                                    class="mr-2"
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    {{ $t("Nachgerückt Mail") }}
                                  </v-btn>
                                </template>
                                <v-card>
                                  <v-toolbar dark color="primary">{{
                                    $t("Nachgerückt Mail")
                                  }}</v-toolbar>
                                  <iframe
                                    style="width:100%; height:500px;"
                                    :src="
                                      '/mail-preview/' +
                                        $route.params.id +
                                        '/new-waiting' +
                                        '?token=' +
                                        this.token
                                    "
                                  ></iframe> </v-card
                              ></v-dialog>
                              <hr class="mt-3 mb-3" />
                              <v-row>
                                <v-col>
                                  <p>{{ $t("Email Text DE") }}</p>
                                  <VueEditor
                                    v-model="formValues.email_new_waiting"
                                    autocomplete="new-password"
                                    v-validate=""
                                    data-vv-name="email_new_waiting"
                                    :error-messages="
                                      errors.collect('email_new_waiting')
                                    "
                                    :editor-toolbar="customToolbar"
                                  ></VueEditor>
                                </v-col>
                                <v-col>
                                  <p>{{ $t("Email Text IT") }}</p>
                                  <VueEditor
                                    v-model="formValues.email_new_waiting_it"
                                    autocomplete="new-password"
                                    v-validate=""
                                    data-vv-name="email_new_waiting_it"
                                    :error-messages="
                                      errors.collect('email_new_waiting_it')
                                    "
                                    :editor-toolbar="customToolbar"
                                  ></VueEditor>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-tab-item>
                          <v-tab-item value="subtab-3">
                            <v-card class="pa-3">
                              <v-dialog v-model="dialog3" width="900">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    color="primary"
                                    class="mr-2"
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    {{ $t("Warteliste") }}
                                  </v-btn>
                                </template>
                                <v-card>
                                  <v-toolbar dark color="primary">{{
                                    $t("Warteliste")
                                  }}</v-toolbar>
                                  <iframe
                                    style="width:100%; height:500px;"
                                    :src="
                                      '/mail-preview/' +
                                        $route.params.id +
                                        '/waiting' +
                                        '?token=' +
                                        this.token
                                    "
                                  ></iframe> </v-card
                              ></v-dialog>
                              <hr class="mt-3 mb-3" />
                              <v-row>
                                <v-col>
                                  <p>{{ $t("Email Text DE") }}</p>
                                  <VueEditor
                                    v-model="formValues.email_waiting"
                                    autocomplete="new-password"
                                    v-validate=""
                                    data-vv-name="email_waiting"
                                    :error-messages="
                                      errors.collect('email_waiting')
                                    "
                                    :editor-toolbar="customToolbar"
                                  ></VueEditor>
                                </v-col>
                                <v-col>
                                  <p>{{ $t("Email Text IT") }}</p>
                                  <VueEditor
                                    v-model="formValues.email_waiting_it"
                                    autocomplete="new-password"
                                    v-validate=""
                                    data-vv-name="email_waiting_it"
                                    :error-messages="
                                      errors.collect('email_waiting_it')
                                    "
                                    :editor-toolbar="customToolbar"
                                  ></VueEditor>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-tab-item>
                          <v-tab-item value="subtab-4">
                            <v-card class="pa-3">
                              <v-dialog v-model="dialog4" width="900">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    color="primary"
                                    class="mr-2"
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    {{ $t("Abgemeldet") }}
                                  </v-btn>
                                </template>
                                <v-card>
                                  <v-toolbar dark color="primary">{{
                                    $t("Abgemeldet")
                                  }}</v-toolbar>
                                  <iframe
                                    style="width:100%; height:500px;"
                                    :src="
                                      '/mail-preview/' +
                                        $route.params.id +
                                        '/deleted' +
                                        '?token=' +
                                        this.token
                                    "
                                  ></iframe> </v-card
                              ></v-dialog>
                              <hr class="mt-3 mb-3" />
                              <v-row>
                                <v-col>
                                  <p>{{ $t("Email Text DE") }}</p>
                                  <VueEditor
                                    v-model="formValues.email_deleted"
                                    autocomplete="new-password"
                                    v-validate=""
                                    data-vv-name="email_deleted"
                                    :error-messages="
                                      errors.collect('email_deleted')
                                    "
                                    :editor-toolbar="customToolbar"
                                  ></VueEditor>
                                </v-col>
                                <v-col>
                                  <p>{{ $t("Email Text IT") }}</p>
                                  <VueEditor
                                    v-model="formValues.email_deleted_it"
                                    autocomplete="new-password"
                                    v-validate=""
                                    data-vv-name="email_deleted_it"
                                    :error-messages="
                                      errors.collect('email_deleted_it')
                                    "
                                    :editor-toolbar="customToolbar"
                                  ></VueEditor>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-tab-item>
                          <v-tab-item value="subtab-5">
                            <v-card class="pa-3">
                              <v-dialog v-model="dialog5" width="900">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    color="primary"
                                    class="mr-2"
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    {{ $t("Bezahlt") }}
                                  </v-btn>
                                </template>
                                <v-card>
                                  <v-toolbar dark color="primary">{{
                                    $t("Bezahlt")
                                  }}</v-toolbar>
                                  <iframe
                                    style="width:100%; height:500px;"
                                    :src="
                                      '/mail-preview/' +
                                        $route.params.id +
                                        '/payed' +
                                        '?token=' +
                                        this.token
                                    "
                                  ></iframe> </v-card
                              ></v-dialog>
                              <hr class="mt-3 mb-3" />
                              <v-row>
                                <v-col>
                                  <p>{{ $t("Email Text DE") }}</p>
                                  <VueEditor
                                    v-model="formValues.email_payed"
                                    autocomplete="new-password"
                                    v-validate=""
                                    data-vv-name="email_payed"
                                    :error-messages="
                                      errors.collect('email_payed')
                                    "
                                    :editor-toolbar="customToolbar"
                                  ></VueEditor>
                                </v-col>
                                <v-col>
                                  <p>{{ $t("Email Text IT") }}</p>
                                  <VueEditor
                                    v-model="formValues.email_payed_it"
                                    autocomplete="new-password"
                                    v-validate=""
                                    data-vv-name="email_payed_it"
                                    :error-messages="
                                      errors.collect('email_payed_it')
                                    "
                                    :editor-toolbar="customToolbar"
                                  ></VueEditor>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-tab-item>
                        </v-tabs-items>
                      </template>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
            </v-tabs-items>

            <v-card-actions class="pl-0">
              <v-btn
                class="mr-4"
                @click="$router.push({ name: 'course.index' })"
              >
                {{ $t("back") }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                v-if="formValues.id"
                color="secondary"
                class="mr-2"
                @click="showItem(formValues)"
                >{{ $t("detail") }}</v-btn
              >
              <v-btn color="primary" class="mr-4" @click="saveItem">
                {{ $t("save") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import courseWeek from "./itemWeek";
import {
  saveItem,
  fetchItem,
  fetchCourseTypes,
  fetchCourses,
  fetchLocations,
  fetchCourseCategories
} from "../shared/services";
export default {
  components: {
    courseWeek
  },
  name: "app-course-item",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      formValues: {
        name: ""
      },
      chosenImage: null,
      chosenFile: null,
      chosenFileHouseRules: null,
      permissions: [],
      loading: true,
      uploaderLoading: false,
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      dialog1: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      dialog5: false,
      token: "",
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        { text: "Email", value: "email" },
        { text: "", value: "action", sortable: false }
      ],
      tab: null,
      subtab: null,
      courseCategories: [],
      courseTypes: [],
      courses: [],
      locations: [],
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"]
      ]
    };
  },
  mounted() {
    this.loading = true;
    this.getData().then(() => {
      if (this.$route.params.id) {
        fetchItem(this.$route.params.id).then(res => {
          this.formValues = res.data;
          this.loading = false;
        });
      } else {
        this.loading = false;
      }
    });
    this.token = localStorage.getItem("laravel-vue-spa");
  },
  computed: {
    computedFormValues() {
      return {
        ...this.formValues
      };
    }
  },
  methods: {
    getData() {
      return Promise.all([
        this.getCourseTypes(),
        this.getCourses(),
        this.getLocations(),
        this.getCourseCategories()
      ]);
    },
    async saveItem() {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveItem(
        this.$route.params.id,
        this.computedFormValues,
        this.$validator
      );
      if (resp.success) {
        this.$root.$notification(resp.message, { type: "success" });
        if (this.$route.params.id) {
          window.location.reload();
        } else {
          this.$router.push({ name: "course.index" });
        }
      }
    },
    async getCourseTypes() {
      this.courseTypes = (await fetchCourseTypes(this.options)).data;
    },
    async getCourses() {
      this.courses = (await fetchCourses(this.options)).data;
    },
    async getLocations() {
      this.locations = (await fetchLocations(this.options)).data;
    },
    async getCourseCategories() {
      this.courseCategories = (await fetchCourseCategories(this.options)).data;
    },
    removeCourseCategory(item) {
      this.formValues.courseCategories = this.formValues.courseCategories.filter(
        _item => (_item.id ? _item.id != item.id : _item != item.id)
      );
    },
    onChangeFileUpload(type) {
      this.fileUpload(type);
    },
    onChangeImageUpload() {
      this.fileUpload("image");
    },
    fileUpload(type) {
      if (this.chosenFile || this.chosenFileHouseRules || this.chosenImage) {
        let formData = new FormData();
        this.uploaderLoading = true;
        if (type == "image") {
          formData.append("image", this.chosenImage);
        } else {
          formData.append("file", this.chosenFile || this.chosenFileHouseRules);
        }
        this.axios
          .post("/api/course/upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(data => {
            this.uploaderLoading = false;
            this.chosenFile = null;
            this.chosenFileHouseRules = null;
            this.chosenImage = null;
            if (type == "program") {
              this.formValues.program = data.data;
            } else if (type == "house_rules") {
              this.formValues.house_rules = data.data;
            } else {
              this.formValues.image = data.data;
            }
          })
          .catch(error => {
            this.loading = false;
            for (let field in error.response.data.errors) {
              this.$validator.errors.add({
                field: field,
                msg: error.response.data.errors[field][0]
              });
            }
            throw error;
          });
      }
    },
    showItem(item) {
      let url = item.id;
      this.$router.push({
        name: "course.show",
        params: { id: url }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
